<template>
  <form :id="id" class="modal-background-layer" @submit.prevent="save">
    <div class="modal-container">
      <div class="modal" :class="modalClass">
        <div class="modal-header modal-top">
          <div class="flex-start-center w-100">
            <div class="modal-title">{{ modalTitle }}</div>
            <slot name="modal-header"></slot>
          </div>
          <div class="modal-buttons">
            <button
              v-if="!hideClose && !hideDefaultButtons"
              type="button"
              class="modal-button cancel"
              @click="close"
            >
              {{ cancelText }}
            </button>
            <button
              v-if="!hideDone && !hideDefaultButtons"
              type="submit"
              class="modal-button done"
            >
              {{ doneText }}
            </button>
            <slot name="modal-buttons"></slot>
          </div>
        </div>
        <div
          class="modal-body modal-middle"
          :class="modalBodyClass"
          :style="noneOverflow ? 'overflow: visible' : ''"
        >
          <slot name="modal-body"></slot>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      isBackgroundScrollLocked: false,
    };
  },
  props: [
    "id",
    "modalTitle",
    "trigger",
    "modalClass",
    "modalBodyClass",
    "hideClose",
    "hideDone",
    "hideDefaultButtons",
    "doneBtnText",
    "cancelBtnText",
    "noneOverflow",
  ],
  emits: ["onSaved", "onClosed"],
  computed: {
    doneText() {
      return this.doneBtnText ? this.doneBtnText : this.$t("modalButton.done");
    },
    cancelText() {
      return this.cancelBtnText
        ? this.cancelBtnText
        : this.$t("modalButton.cancel");
    },
  },
  watch: {
    trigger(value) {
      if (value) {
        this.$nextTick(() => {
          document.getElementById(this.id).classList.add("show");
        });
        this.lockBackgroundScroll();
      } else {
        document.getElementById(this.id).classList.remove("show");
        this.unlockBackgroundScroll();
      }
    },
  },
  mounted() {
    if (this.trigger) {
      this.lockBackgroundScroll();
    }
  },
  beforeUnmount() {
    this.unlockBackgroundScroll();
  },
  methods: {
    close() {
      this.$emit("onClosed");
    },
    save() {
      this.$emit("onSaved");
    },
    lockBackgroundScroll() {
      if (this.isBackgroundScrollLocked) return;

      const lockCount = Number(document.body.dataset.modalScrollLockCount || 0);

      if (lockCount === 0) {
        document.body.dataset.modalPreviousOverflow =
          document.body.style.overflow || "";
        document.body.style.overflow = "hidden";
      }

      document.body.dataset.modalScrollLockCount = String(lockCount + 1);
      this.isBackgroundScrollLocked = true;
    },
    unlockBackgroundScroll() {
      if (!this.isBackgroundScrollLocked) return;

      const lockCount = Math.max(
        Number(document.body.dataset.modalScrollLockCount || 0) - 1,
        0
      );

      if (lockCount === 0) {
        document.body.style.overflow =
          document.body.dataset.modalPreviousOverflow || "";
        delete document.body.dataset.modalScrollLockCount;
        delete document.body.dataset.modalPreviousOverflow;
      } else {
        document.body.dataset.modalScrollLockCount = String(lockCount);
      }

      this.isBackgroundScrollLocked = false;
    },
  },
};
</script>
